<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Metricas CRM - Digitalizador",
            items: [
                {
                    text: "Digitalizador",
                    href: "/web/digitalizar/asociar"
                },
                {
                    text: "Metricas CRM",
                    active: true
                }
            ],
            loading: false,
            error: "",
            actualizadoEn: null,
            rangoDisponible: {
                desde: null,
                hasta: null,
            },
            filtros: {
                fecha_desde: "",
                fecha_hasta: "",
                evento_codigo: "",
                estado_final: "",
                origen: "",
                success: "",
                batch_id: "",
                buscar: "",
                page: 1,
                per_page: 50,
            },
            resumen: {
                total: 0,
                total_envios_crm: 0,
                omitidos_sin_http: 0,
                exitosos: 0,
                fallidos: 0,
                tasa_exito: 0,
                promedio_http_ms: 0,
                promedio_job_ms: 0,
                max_http_ms: 0,
                max_job_ms: 0,
                estados: [],
            },
            opciones: {
                estado_final: [],
                origen: [],
            },
            paginacion: {
                page: 1,
                per_page: 50,
                total: 0,
                total_pages: 1,
            },
            registros: [],
        };
    },
    computed: {
        esUsuarioAutorizado() {
            return Number(this.user && this.user.id) === 1;
        },
        successRateLabel() {
            return `${Number(this.resumen.tasa_exito || 0).toFixed(2)}%`;
        },
        hasHttpCall() {
            return (row) => Boolean(row && row.request_started_at && row.http_status && row.duration_http_ms);
        },
        canGoPrev() {
            return Number(this.paginacion.page || 1) > 1;
        },
        canGoNext() {
            return Number(this.paginacion.page || 1) < Number(this.paginacion.total_pages || 1);
        }
    },
    methods: {
        formatDateTime(value) {
            if (!value) {
                return '-';
            }

            return new Date(value).toLocaleString('es-CL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        },
        formatMs(value) {
            const n = Number(value || 0);
            if (!n) {
                return '-';
            }
            return `${n.toLocaleString('es-CL')} ms`;
        },
        async cargarMetricas(resetPage = false) {
            if (!this.esUsuarioAutorizado) {
                return;
            }

            if (resetPage) {
                this.filtros.page = 1;
            }

            this.loading = true;
            this.error = "";

            try {
                const params = {
                    fecha_desde: this.filtros.fecha_desde || undefined,
                    fecha_hasta: this.filtros.fecha_hasta || undefined,
                    evento_codigo: this.filtros.evento_codigo || undefined,
                    estado_final: this.filtros.estado_final || undefined,
                    origen: this.filtros.origen || undefined,
                    success: this.filtros.success || undefined,
                    batch_id: this.filtros.batch_id || undefined,
                    buscar: this.filtros.buscar || undefined,
                    page: this.filtros.page,
                    per_page: this.filtros.per_page,
                };

                const response = await axios.get('/api/digitalizar/crm_metricas', { params });
                const data = response.data || {};

                if (!data.estado) {
                    this.error = data.mensaje || 'No se pudieron cargar las metricas CRM.';
                    return;
                }

                this.resumen = data.resumen || this.resumen;
                this.opciones = data.opciones || this.opciones;
                this.paginacion = data.paginacion || this.paginacion;
                this.registros = Array.isArray(data.registros) ? data.registros : [];
                this.rangoDisponible = data.rango_disponible || this.rangoDisponible;
                this.actualizadoEn = data.actualizado_en || null;
            } catch (error) {
                const status = error && error.response ? error.response.status : null;
                if (status === 403) {
                    window.location.href = '/';
                    return;
                }

                this.error = 'Error al cargar metricas CRM.';
            } finally {
                this.loading = false;
            }
        },
        aplicarFiltros() {
            this.cargarMetricas(true);
        },
        limpiarFiltros() {
            this.filtros = {
                fecha_desde: "",
                fecha_hasta: "",
                evento_codigo: "",
                estado_final: "",
                origen: "",
                success: "",
                batch_id: "",
                buscar: "",
                page: 1,
                per_page: this.filtros.per_page,
            };
            this.cargarMetricas(true);
        },
        cambiarPerPage() {
            this.filtros.page = 1;
            this.cargarMetricas(false);
        },
        prevPage() {
            if (!this.canGoPrev || this.loading) {
                return;
            }
            this.filtros.page = Number(this.filtros.page || 1) - 1;
            this.cargarMetricas(false);
        },
        nextPage() {
            if (!this.canGoNext || this.loading) {
                return;
            }
            this.filtros.page = Number(this.filtros.page || 1) + 1;
            this.cargarMetricas(false);
        }
    },
    created() {
        if (!this.esUsuarioAutorizado) {
            window.location.href = '/';
            return;
        }

        this.cargarMetricas(true);
    }
};
</script>

<template>
    <Layout>
        <div v-if="!esUsuarioAutorizado"></div>
        <template v-else>
            <PageHeader :title="title" :items="items" />

            <div class="row mb-3">
                <div class="col-12 d-flex justify-content-between align-items-center">
                    <small class="text-muted">
                        Ultima actualizacion: {{ formatDateTime(actualizadoEn) }}
                        <span v-if="rangoDisponible.desde || rangoDisponible.hasta" class="ml-2">
                            | Rango metricas: {{ formatDateTime(rangoDisponible.desde) }} - {{ formatDateTime(rangoDisponible.hasta) }}
                        </span>
                    </small>
                    <button class="btn btn-sm btn-primary" @click="cargarMetricas(false)" :disabled="loading">Actualizar</button>
                </div>
            </div>

            <div class="card mb-3">
                <div class="card-body">
                    <h5 class="mb-3">Filtros</h5>
                    <div class="row">
                        <div class="col-md-2 mb-2">
                            <label class="mb-1">Desde</label>
                            <input type="date" class="form-control" v-model="filtros.fecha_desde">
                        </div>
                        <div class="col-md-2 mb-2">
                            <label class="mb-1">Hasta</label>
                            <input type="date" class="form-control" v-model="filtros.fecha_hasta">
                        </div>
                        <div class="col-md-2 mb-2">
                            <label class="mb-1">Evento codigo</label>
                            <input type="text" class="form-control" v-model="filtros.evento_codigo" placeholder="EV-12187-A">
                        </div>
                        <div class="col-md-2 mb-2">
                            <label class="mb-1">Estado final</label>
                            <select class="form-control" v-model="filtros.estado_final">
                                <option value="">Todos</option>
                                <option v-for="estado in opciones.estado_final" :key="estado" :value="estado">{{ estado }}</option>
                            </select>
                        </div>
                        <div class="col-md-2 mb-2">
                            <label class="mb-1">Origen</label>
                            <select class="form-control" v-model="filtros.origen">
                                <option value="">Todos</option>
                                <option v-for="item in opciones.origen" :key="item" :value="item">{{ item }}</option>
                            </select>
                        </div>
                        <div class="col-md-2 mb-2">
                            <label class="mb-1">Resultado</label>
                            <select class="form-control" v-model="filtros.success">
                                <option value="">Todos</option>
                                <option value="1">Exitoso</option>
                                <option value="0">Fallido</option>
                            </select>
                        </div>
                        <div class="col-md-2 mb-2">
                            <label class="mb-1">Batch ID</label>
                            <input type="number" min="1" class="form-control" v-model="filtros.batch_id" placeholder="1">
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="mb-1">Buscar</label>
                            <input type="text" class="form-control" v-model="filtros.buscar" placeholder="error, imagen_id, evento_id, laborante_id...">
                        </div>
                        <div class="col-md-4 mb-2 d-flex align-items-end">
                            <div class="d-flex" style="gap: 0.5rem;">
                                <button class="btn btn-primary" @click="aplicarFiltros" :disabled="loading">Aplicar</button>
                                <button class="btn btn-outline-secondary" @click="limpiarFiltros" :disabled="loading">Limpiar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="error" class="alert alert-danger">{{ error }}</div>

            <div class="row">
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-1">Total auditado</p>
                            <h4 class="mb-0">{{ resumen.total }}</h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-1">Envios CRM reales</p>
                            <h4 class="mb-0">{{ resumen.total_envios_crm || 0 }}</h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-1">Tasa exito CRM</p>
                            <h4 class="mb-0 text-success">{{ successRateLabel }}</h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-1">Promedio HTTP CRM</p>
                            <h4 class="mb-0">{{ formatMs(resumen.promedio_http_ms) }}</h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-1">Omitidos sin HTTP</p>
                            <h4 class="mb-0 text-warning">{{ resumen.omitidos_sin_http || 0 }}</h4>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6">
                    <div class="card mini-stats-wid">
                        <div class="card-body">
                            <p class="text-muted mb-1">Promedio Job</p>
                            <h4 class="mb-0">{{ formatMs(resumen.promedio_job_ms) }}</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-4">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="mb-2">Estados finales (filtro actual)</h5>
                            <div class="table-responsive">
                                <table class="table table-sm table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>Estado</th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in resumen.estados" :key="item.estado">
                                            <td>{{ item.estado }}</td>
                                            <td class="text-right">{{ item.total }}</td>
                                        </tr>
                                        <tr v-if="!resumen.estados || !resumen.estados.length">
                                            <td colspan="2" class="text-center text-muted">Sin datos</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-8">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h5 class="mb-0">Registros de envio CRM</h5>
                                <div class="d-flex align-items-center" style="gap: 0.5rem;">
                                    <span class="text-muted small">Por pagina</span>
                                    <select class="form-control form-control-sm" style="width: 90px;" v-model.number="filtros.per_page" @change="cambiarPerPage">
                                        <option :value="25">25</option>
                                        <option :value="50">50</option>
                                        <option :value="100">100</option>
                                        <option :value="200">200</option>
                                    </select>
                                </div>
                            </div>

                            <div class="table-responsive">
                                <table class="table table-sm table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th>Fecha req</th>
                                            <th>Evento</th>
                                            <th>Imagen</th>
                                            <th>Batch</th>
                                            <th>Estado ini/final</th>
                                            <th>HTTP</th>
                                            <th>T. HTTP</th>
                                            <th>T. Job</th>
                                            <th>Intento</th>
                                            <th>Resultado</th>
                                            <th>Error</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="row in registros" :key="row.id">
                                            <td>{{ formatDateTime(row.request_started_at || row.created_at) }}</td>
                                            <td>
                                                <div>{{ row.evento_codigo || '-' }}</div>
                                                <small class="text-muted">ID: {{ row.evento_id || '-' }}</small>
                                            </td>
                                            <td>{{ row.imagen_id || '-' }}</td>
                                            <td>
                                                <div>{{ row.batch_id || '-' }}</div>
                                                <small class="text-muted">{{ row.batch_status || '-' }}</small>
                                            </td>
                                            <td>
                                                <small class="text-muted">{{ row.estado_crm_inicial || '-' }}</small>
                                                <div>{{ row.estado_crm_final || '-' }}</div>
                                            </td>
                                            <td>{{ row.http_status || '-' }}</td>
                                            <td>{{ formatMs(row.duration_http_ms) }}</td>
                                            <td>{{ formatMs(row.duration_job_ms) }}</td>
                                            <td>{{ row.attempt || '-' }}</td>
                                            <td>
                                                <span v-if="!hasHttpCall(row)" class="badge badge-secondary">OMITIDO</span>
                                                <span v-else-if="Number(row.success)===1" class="badge badge-success">OK</span>
                                                <span v-else class="badge badge-danger">ERROR</span>
                                            </td>
                                            <td class="text-truncate" style="max-width: 260px;">{{ row.error_message || '-' }}</td>
                                        </tr>
                                        <tr v-if="!registros.length">
                                            <td colspan="11" class="text-center text-muted py-3">Sin registros para los filtros seleccionados</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="d-flex justify-content-between align-items-center mt-3">
                                <small class="text-muted">
                                    Pagina {{ paginacion.page }} de {{ paginacion.total_pages }} · Total {{ paginacion.total }}
                                </small>
                                <div class="d-flex" style="gap: 0.5rem;">
                                    <button class="btn btn-sm btn-outline-secondary" @click="prevPage" :disabled="!canGoPrev || loading">Anterior</button>
                                    <button class="btn btn-sm btn-outline-secondary" @click="nextPage" :disabled="!canGoNext || loading">Siguiente</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Layout>
</template>
